import config from "../config";

export const BaseURL = config.API_BASE_URL;
export const loginURL = `${BaseURL}/team/dashboard/login`;
export const logoutURL = `${BaseURL}/team/dashboard/logout`;
export const userInfo = `${BaseURL}/team/dashboard/loggedInInfo`;
export const profileURL = `${BaseURL}/team/dashboard/home`;
export const missionURL = `${BaseURL}/team/dashboard/missions`;
export const teamsURL = `${BaseURL}/team/dashboard/teams`;
export const membersURL = `${BaseURL}/team/dashboard/members`;
export const coachesURL = `${BaseURL}/team/dashboard/coaches`;
export const categoriesURL = `${BaseURL}/team/dashboard/categories`;
export const paymentURL = `${BaseURL}/team/dashboard/payment/credit`;
export const transactionsURL = `${BaseURL}/team/dashboard/payment/transactions`;
export const verifyURL = `${BaseURL}/team/dashboard/verify`;
